// (C) Copyright IBM Deutschland GmbH 2021.  All rights reserved.

/***********************************************************************************************
import
***********************************************************************************************/

import React from 'react';
import { StyleSheet, View, Modal, ActivityIndicator, Text } from 'react-native';

import { theme } from '../../config';
import translate from '../../services/localization';
import PropTypes from 'prop-types';

/***********************************************************************************************
 * component:
 * displays a fullscreen-loading animation (a simple spinner)
 ***********************************************************************************************/
function Spinner({ message = null }) {
  return (
    <Modal
      visible={true}
      testID="Spinner"
      transparent={true} // Makes the underlying screen visible beneath the modal
      animationType="fade"
    >
      <View style={localStyle.container}>
        <View style={localStyle.dialogBox}>
          <ActivityIndicator size={32} style={localStyle.activityIndicator} />
          <Text style={localStyle.loadingText}>
            {message || translate('generic').wait}
          </Text>
        </View>
      </View>
    </Modal>
  );
}

Spinner.propTypes = {
  message: PropTypes.string,
};

/***********************************************************************************************
local styling
***********************************************************************************************/

const localStyle = StyleSheet.create({
  activityIndicator: {
    flex: 1,
  },

  background: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },

  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    // Using an rgba color for a translucent dark overlay background
    backgroundColor: 'rgba(0, 0, 0, 0.40)',
  },
  dialogBox: {
    width: 200,
    padding: 25,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    // Optional shadow for iOS/Android depth
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  loadingText: {
    paddingTop: 12,
    fontSize: 16,
    fontWeight: '600',
    color: '#333333',
    textAlign: 'center',
  },
});

/***********************************************************************************************
export
***********************************************************************************************/

export default Spinner;
